import { configure, defineRule } from 'vee-validate'
import { isValidPassword, isValidPhoneNumber } from '../utils/validators'

// Define validation rules with clear error messages
defineRule('required', (value: any) => {
  if (value === null || value === undefined || value === '') {
    return 'This field is required'
  }
  if (Array.isArray(value) && !value.length) {
    return 'This field is required'
  }
  return true
})

defineRule('email', (value: any) => {
  if (!value) return true
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
  if (!emailRegex.test(value)) {
    return 'Please enter a valid email'
  }
  return true
})

defineRule('alpha', (value: any) => {
  if (!value) return true
  const alphaRegex = /^[A-Za-z\s]+$/
  if (!alphaRegex.test(value)) {
    return 'Only alphabetic characters are allowed'
  }
  return true
})

defineRule('numeric', (value: any) => {
  if (!value) return true
  const numericRegex = /^\d+$/
  if (!numericRegex.test(value)) {
    return 'Only numeric characters are allowed'
  }
  return true
})

defineRule('alphanumeric', (value: any) => {
  if (!value) return true
  const alphanumericRegex = /^[A-Za-z0-9\s]+$/
  if (!alphanumericRegex.test(value)) {
    return 'Only alphanumeric characters are allowed'
  }
  return true
})

defineRule('password', (value: any) => {
  if (!value) return true
  const result = isValidPassword(value)
  if (!result.isValid) {
    return result.errors[0] // Return the first error message
  }
  return true
})

defineRule('phone', (value: any) => {
  if (!value) return true
  if (!isValidPhoneNumber(value)) {
    return 'Please enter a valid phone number (minimum 10 digits)'
  }
  return true
})

defineRule('min', (value: any, [limit]: any) => {
  if (!value || !value.length) return true
  if (value.length < limit) {
    return `Must be at least ${limit} characters`
  }
  return true
})

defineRule('max', (value: any, [limit]: any) => {
  if (!value || !value.length) return true
  if (value.length > limit) {
    return `Must not exceed ${limit} characters`
  }
  return true
})

// Configure vee-validate
configure({
  validateOnBlur: true, // Only validate when field loses focus
  validateOnChange: false, // Don't validate on every change
  validateOnInput: false, // Don't validate on every input
  validateOnModelUpdate: false, // Don't validate on model update
  bails: false, // Don't stop on first error
  generateMessage: (ctx: any) => {
    const fieldName = ctx.field || 'This field'
    const messages: Record<string, string> = {
      required: `${fieldName} is required`,
      email: 'Please enter a valid email',
      alpha: 'Only alphabetic characters are allowed',
      numeric: 'Only numeric characters are allowed',
      alphanumeric: 'Only alphanumeric characters are allowed',
      password: ctx.message, // Use the message from the password rule
      phone: ctx.message, // Use the message from the phone rule
      min: `Must be at least ${ctx.rule?.params?.[0]} characters`,
      max: `Must not exceed ${ctx.rule?.params?.[0]} characters`
    }

    // Get the message for the rule
    const message = messages[ctx.rule?.name]
    if (message) return message

    // If no message is found, return a generic error
    return `${fieldName} is invalid`
  }
})

// Export the configuration
export default {}
